import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=e28a7576&scoped=true&"
import script from "./Supplier.vue?vue&type=script&lang=js&"
export * from "./Supplier.vue?vue&type=script&lang=js&"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=e28a7576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a7576",
  null
  
)

export default component.exports